import { isLabsEnvironment } from 'helpers/feature-toggle';

export const API_ACCESS_ROUTE = '/engage/api-access';

/**
 * The "API access" section is currently limited to the labs environment (this also
 * covers local dev / dev-prod, which report `labs`). Gates both the route registration
 * and the left-nav entry so the feature is fully absent outside labs — not just hidden.
 */
export const isApiAccessEnabled = (): boolean => isLabsEnvironment();

export enum ApiAccessTab {
  PersonalAccessTokens = 'personal-access-tokens',
  OauthClients = 'oauth-clients',
  Webhooks = 'webhooks',
  Mcp = 'mcp',
}

export interface IApiAccessTabConfig {
  /** The tab id doubles as its route path segment relative to API_ACCESS_ROUTE. */
  id: ApiAccessTab;
  label: string;
}

export const API_ACCESS_TABS: IApiAccessTabConfig[] = [
  { id: ApiAccessTab.PersonalAccessTokens, label: 'Personal access tokens' },
  { id: ApiAccessTab.OauthClients, label: 'OAuth clients' },
  { id: ApiAccessTab.Webhooks, label: 'Webhooks' },
  { id: ApiAccessTab.Mcp, label: 'MCP' },
];

/** Public API documentation page. */
export const API_DOCS_URL = 'https://www.text.com/docs';

/** Public API pricing page (marketing). */
export const API_PRICING_URL = 'https://www.text.com/pricing';
